const MOBILE_USER_AGENT = /Android|iPhone|iPad|iPod/i

export const isMobileDevice = (userAgent = '') =>
  MOBILE_USER_AGENT.test(userAgent)

export const getMobileConfirmationUrl = token =>
  `enerqiqmobile://confirm/${encodeURIComponent(token)}`
